import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import Crypto_Token_Slider from "../service/Crypto_Token_Slider";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import { algotradepageform } from "../../config/apiCall";
import httpService from "../../config/httpCall";
import { toastAlert } from "../../config/toastAlert";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import useState from "react-usestateref"; // see this line
// import { toastAlert } from "../../config/toastAlert";
// import httpService from "../../config/httpCall";
import { sendcontactpageContacts } from "../../config/apiCall";
import PhoneInput from "react-phone-input-2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
};

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  const NewFormValue = {
    username: "",
    useremail: "",
    usermessage: "",
  };
  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...newValue, ...{ [name]: value } };
      setnewValue(formData);
    } catch (error) {}
  };

  const [usernameErr, setusernameErr] = useState(false);
  const [useremailErr, setuseremailErr] = useState(false);
  const [usermessageErr, setusermessageErr] = useState(false);
  const [validationErrors, setvalidationErrors] = useState("");
  const [validateErr, setvalidateErr] = useState("");
  const sendQuestion = async () => {
    try {
      validate(NewFormValue);
      if (useremail != "" && usermessage != "" && username != "") {
        if (validateErr == false) {
          var obj = {
            username: username,
            usermessage: usermessage,
            useremail: useremail,
          };
          var obj = {
            apiUrl: httpService.algotradepageform,
            payload: obj,
          };
          var messageSent = await algotradepageform(obj);
          if (messageSent) {
            NewFormValue.useremail = "";
            NewFormValue.username = "";
            NewFormValue.usermessage = "";
            toastAlert("success", messageSent.Message);
          } else {
            useremail = "";
            username = "";
            usermessage = "";
            toastAlert("error", messageSent.Message);
          }
        } else {
        }
      } else {
        validate(NewFormValue);
      }
    } catch (err) {}
  };
  const validate = async () => {
    try {
      var error = {};

      if (newValue.username == "") {
        setusernameErr(true);
        setvalidateErr(true);
        error.username = "Must Enter the field";
      } else {
        setusernameErr(false);
        setvalidateErr(false);
      }
      if (newValue.usermessage == "") {
        setusermessageErr(true);
        setvalidateErr(true);

        error.usermessage = "Must Enter the field";
      } else {
        setusermessageErr(false);
        setvalidateErr(false);
      }

      if (newValue.useremail == "") {
        setuseremailErr(true);
        setvalidateErr(true);

        error.useremail = "Must Enter the field ";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(newValue.useremail)
      ) {
        setuseremailErr(true);
        setvalidateErr(true);

        error.useremail = "Invalid Mail";
      } else {
        setuseremailErr(false);
        setvalidateErr(false);
      }

      setvalidationErrors(error);
    } catch (error) {}
  };
  const [newValue, setnewValue] = useState(NewFormValue);
  const { username, useremail, usermessage } = newValue;
  const processes_leading = {
    arrows: false,
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <div className="newpage   blog_page Token_content Token_SR">
      <header className="newpage   ">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span className="crypto-token-dev-page">
            <Helmet>
              <title>
                Token Development Company
              </title>
              <link
                rel="canonical"
                href="https://www.beleaftechnologies.com/token-development-company"
              />
              <meta
                name="title"
                content="Token Development Company "
              />
              <meta
                name="description"
                content="Being the best token development company, Beleaf offers top-rated crypto token development services with our certified token developers to create tokens."
              />
              <meta
                name="keywords"
                content="token development company, token creation services, token development services,Crypto token development company,crypto token development services,create your own token, token development, token development solutions, ethereum token development, tron token development, bep20 token development, nft token development, token creation, Launch your Token,Crypto Token development
                "
              />
            </Helmet>
            <section className="token-hero-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 cryto-hero-collumn">
                    <div className="token-hero-content">
                      <h1>Token Development Company</h1>
                      <p>
                        As a leading crypto token development company, we
                        specialize in creating secure, scalable, and
                        feature-rich crypto tokens tailored to meet the unique
                        needs of our clients. From startups to established
                        enterprises, we empower businesses to harness the full
                        potential of blockchain technology.
                      </p>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="consulation-butn"
                      >
                        Get Free Consultation
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="token-hero-banner">
                      <img
                        src={require("../../image/new_token-development/token-hero-banner.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="crypto-premium-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="crypto-premium-banner">
                      <img
                        src={require("../../image/new_token-development/token-banner2.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="crypto-premium-content">
                      <h3>What is</h3>
                      <h2>Crypto Token Development</h2>
                      <p>
                        Crypto token development involves creating digital
                        assets on blockchain platforms that represent value or
                        utility. These tokens can be used for various purposes,
                        such as payments, access to services, or ownership of
                        assets. The process includes designing, coding, and
                        deploying tokens with features like security,
                        scalability, and compliance. It’s a key step for
                        businesses to leverage blockchain technology for
                        innovation. Crypto tokens empower industries like
                        finance, gaming, and real estate with transparency and
                        decentralization.
                      </p>
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="consulation-butn"
                      >
                        Get Free Consultation
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="our-premium-crypto-section">
              <div className="container">
                <div className="our-premium-crypto-heading">
                  <h3>Our Premium Crypto</h3>
                  <h2>Token Development Services</h2>
                  <p>
                    We execute a series of studies based on your ideas in order
                    to incorporate the
                    <br /> rapidly evolving mechanics into your project. Our
                    token development services go
                    <br /> through many stages of development that we have met.
                  </p>
                </div>
                <>
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    navigation={true}
                    modules={[Navigation]}
                    pagination={{
                      clickable: true,
                    }}
                    breakpoints={{
                      400: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                      540: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                      },
                    }}
                    className="mySwiper flash-slider"
                  >
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card ethereum">
                        <img
                          src={require("../../image/new_token-development/ethereum-card.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Ethereum Token Development</h3>
                        <p>
                          You can create your own Ethereum Tokens by customising
                          smart contracts and auditing them against several
                          Ethereum Standards, such as ERC-20, ERC-223, ERC-777,
                          ERC-1400, ERC-721, ERC-827, and ERC-1155.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card tron">
                        <img
                          src={require("../../image/new_token-development/tron-token.webp")}
                          alt="Token Development Company"
                        />
                        <h3>TRON Token Development</h3>
                        <p>
                          Create TRON tokens for the enhancement of any
                          blockchain dApps based on TRON's most recommended
                          token specifications TRC-10, TRC-20, and TRC-721.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card polygon">
                        <img
                          src={require("../../image/new_token-development/polygon-token.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Polygon Token Development</h3>
                        <p>
                          Develop Polygon tokens to enhance scalability and
                          reduce transaction costs. Perfect for creating
                          decentralized apps and services. Benefit from faster
                          transactions and lower fees. Capacitate your projects
                          with Polygon's Layer 2 solutions.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card solana">
                        <div className="solana-padding">
                          <img
                            src={require("../../image/new_token-development/solana-token.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Solana Token Development</h3>
                          <p>
                            Develop your token on Solana blockchain for
                            high-speed, low-cost blockchain solutions. Ideal for
                            decentralized finance (DeFi) and Web3 applications.
                            Experience lightning-fast transactions. Boost your
                            projects with Solana's powerful blockchain
                            technology.
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card bsc-token">
                        <img
                          src={require("../../image/new_token-development/bsc-token.webp")}
                          alt="Token Development Company"
                        />
                        <h3>BSC Token Development</h3>
                        <p>
                          BSC tokens for a fast and efficient blockchain
                          experience. Suitable for DeFi, NFTs, and more. Enjoy
                          low fees and high performance. Strengthen your
                          projects with Binance Smart Chain's robust network.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="why-choose-slider-token">
                      <div className="technical-assistance-card avalanche">
                        <img
                          src={require("../../image/new_token-development/avalanche-token.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Avalanche Token Development</h3>
                        <p>
                          Create tokens on avalanche for rapid and secure
                          blockchain transactions. Perfect for DeFi, enterprise
                          solutions, and more. Benefit from low fees and high
                          scalability. Enhance your projects with Avalanche's
                          advanced technology.
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="our-premium-crypto-none-slider"></SwiperSlide>
                  </Swiper>
                </>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="consulation-butn contact-us-btn"
                >
                  Contact Us
                </button>
              </div>
            </section>
            <section className="crypto-token-types-section">
              <div className="container">
                <div className="our-premium-crypto-heading">
                  <h3>Our </h3>
                  <h2>Crypto Token Development Services</h2>
                  <p>
                    As a trusted crypto token development company, we offer a
                    wide range of services designed to meet the diverse needs of
                    our clients:
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/security-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>Security Token Development</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          Security tokens represent ownership in an asset, such
                          as real estate or equity, and are subject to
                          regulatory compliance. Our team ensures that your
                          security tokens adhere to all relevant regulations,
                          providing a seamless and secure investment experience.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/Equity-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>Custom Token Development</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          Need a token that doesn’t fit the standard mold? We
                          offer custom token development services to create
                          tokens with unique functionalities and features.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/utility-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>NFT Development</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          Non-Fungible Tokens (NFTs) have revolutionized digital
                          ownership. Our crypto token development company
                          creates unique and valuable NFTs for industries such
                          as art, gaming, and entertainment.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/non-fungible-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>Utility Token Development</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          Utility tokens play a crucial role in blockchain
                          ecosystems, providing users with access to specific
                          services or platforms. We specialize in creating
                          versatile utility tokens that drive user engagement
                          and business growth.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/defi-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>DeFi Token Development</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          Decentralized Finance (DeFi) tokens are at the
                          forefront of financial innovation. We develop DeFi
                          tokens that enable lending, borrowing, and trading in
                          decentralized ecosystems.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="token-type-card">
                      <div className="token-type-icon">
                        <img
                          src={require("../../image/new_token-development/metaverse-token.webp")}
                          alt="Token Development Company"
                        />
                        <h4>Token Migration and Integration</h4>
                      </div>
                      <div className="utility-token-content">
                        <div className="utility-token-content-des">
                          If you need to migrate your token to a new blockchain
                          or integrate it with existing platforms, our team
                          ensures a smooth transition with minimal downtime.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="we-work-with-token-section">
              <div className="container">
                <div className="we-work-with-token-content">
                  <h3>We Work With</h3>
                  <h2>Token Standards</h2>
                  <p>
                    We are developing numerous token standards for your
                    <br /> specific preferences and progressive business growth
                    in the
                    <br />
                    blockchain space.
                  </p>
                </div>
                <div className="we-work-with-token-bg-banner">
                  <img
                    src={require("../../image/new_token-development/we-work-token-bg.webp")}
                    alt="Token Development Company"
                  />
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="smart-chain-list">
                      <h3>Binance Smart Chain(BSC)</h3>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>BEP-20 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>BEP-721 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span> BEP1155 </span>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="smart-chain-list binance-smart-list">
                      <h3>Ethereum</h3>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>ERC-20 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>ERC-223</span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span> ERC-720/721 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span> ERC-777 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span> ERC-998 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>ERC-1155</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="smart-chain-list tron-smart-list">
                      <h3>Tron</h3>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>TRC-10 </span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>TRC-20</span>
                      </p>
                      <p>
                        <i className="ri-checkbox-circle-line"></i>{" "}
                        <span>TRC-721</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="specification-of-development-section">
              <div className="container">
                <div className="specification-of-title">
                  <h3>Specifications Of</h3>
                  <h2>Token Development</h2>
                  <p>
                    Our Token Development Services Are Jam-Packed With Excellent
                    Features That Offer Significant
                    <br /> Advantages To Token Owners As Well As Users. Here Are
                    Some Of Our Tokens' Standout
                    <br />
                    Characteristics That You Might Enjoy.
                  </p>
                </div>
                <div>
                  <>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      navigation={true}
                      modules={[Navigation]}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 3,
                          spaceBetween: 50,
                        },
                      }}
                      className="mySwiper flash-slider"
                    >
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/document.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Documented</h3>
                          <p>
                            Your Token will fully conform to the ERC20 concept
                            and be compatible with every ERC20 wallet in the
                            world. It has decimal points, a name, and a symbol.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/burnable.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Burnable</h3>
                          <p>
                            Your Token will be ready to burn. It indicates that
                            you can reduce the supply in circulation by burning
                            any of the tokens.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/pausable.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Pausable</h3>
                          <p>
                            Your token's movement may be slowed. Trading should
                            be prohibited until all token transactions have been
                            unfrozen.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/Mintable.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Mintable</h3>
                          <p>
                            You will make tokens via minting. The token can only
                            be created by its owner. You can also disable
                            minting if you don't want to create any more tokens.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/Capped.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Capped</h3>
                          <p>
                            It is not possible to create more tokens than the
                            given token limit. This stops anyone from producing
                            more tokens than have been announced.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide className="why-choose-slider-token">
                        <div className="documented-slider-item">
                          <img
                            src={require("../../image/new_token-development/Ownership.webp")}
                            alt="Token Development Company"
                          />
                          <h3>Ownership Possibility</h3>
                          <p>
                            Your token is now all yours. Token holders can also
                            generate and manage new tokens.
                          </p>
                        </div>
                      </SwiperSlide>

                      <SwiperSlide className="our-premium-crypto-none-slider"></SwiperSlide>
                    </Swiper>
                  </>
                </div>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="documented-Get-quote-btn"
                >
                  Get A Quote
                </button>
              </div>
            </section>
            <section className="benefits-of-token-section">
              <div className="container">
                <div className="our-premium-crypto-heading">
                  <h3>Why Choose Our</h3>
                  <h2>Crypto Token Development Company?</h2>
                  <p>
                    As a premier crypto token development company, we bring
                    years of experience and expertise to the table. Our team of
                    blockchain developers, smart contract specialists, and
                    market strategists work collaboratively to deliver
                    high-quality crypto token solutions. Here’s why clients
                    trust us:
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-5">
                    <div className="benefits-of-token-banner">
                      <img
                        src={require("../../image/new_token-development/benefits-token-banner.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 branding-boxes">
                    <div className="col-lg-6">
                      <div className="branding-box">
                        <img
                          src={require("../../image/new_token-development/branding.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Expertise in Blockchain Platforms</h3>
                        <p>
                          We have in-depth knowledge of leading blockchain
                          platforms, including Ethereum, Binance Smart Chain,
                          Polygon, Solana, and more. This allows us to recommend
                          the best platform for your crypto token project.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="branding-box">
                        <img
                          src={require("../../image/new_token-development/exchange.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Customized Solutions</h3>
                        <p>
                          We understand that every project is unique. Our crypto
                          token development company provides tailored solutions
                          that align with your business objectives, whether you
                          need utility tokens, security tokens, or NFTs.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="branding-box">
                        <img
                          src={require("../../image/new_token-development/popularity.webp")}
                          alt="Token Development Company"
                        />
                        <h3>End-to-End Development Services</h3>
                        <p>
                          From ideation to deployment, we offer comprehensive
                          services to ensure the successful launch of your
                          crypto token. Our services include token design,
                          development, smart contract creation, testing, and
                          marketing.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="branding-box">
                        <img
                          src={require("../../image/new_token-development/fundraising.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Security First</h3>
                        <p>
                          Security is paramount in crypto token development. We
                          employ robust security measures, including rigorous
                          testing and audits, to protect your token from
                          vulnerabilities and breaches.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/*Token Slider  */}
                <div className="our-premium-crypto-heading blockchain-platforms">
                  <h3>Our Familiarity With</h3>
                  <h2>Blockchain Platforms</h2>
                  <p>
                    Utilize any of your favourite top blockchain networks to
                    create your own crypto token.{" "}
                  </p>
                </div>
                <div>
                  <Slider {...processes_newew}>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-ethereum.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-tezos.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/cosmos-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/algorand-slider.webp")}
                        alt="Crypto Token development"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/polkadot-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/solana-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/tron-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/polygon-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                  </Slider>
                </div>
                {/*  */}
              </div>
            </section>
            <section className="leading-industries-slider-section">
              <div className="container">
                <div className="our-premium-crypto-heading blockchain-platforms">
                  <h3>Features of Tokens Developed by</h3>

                  <h2> Our Crypto Token Development Company</h2>
                  <p>
                    Our tokens are designed to stand out in the competitive
                    crypto market. Here are some of the key features we offer:
                  </p>
                </div>
                <div>
                  <Slider {...processes_leading}>
                    {/* 1 */}
                    <div className="logo_clinet_img token-dev">
                      <div className="virtual_games">
                        {/* <img
                          src={require("../../image/new_token-development/virtual-games.webp")}
                          alt="Token Development Company"
                        /> */}
                        <h3>High Scalability</h3>
                        <p>
                          Capable of handling a large number of transactions
                          without compromising performance.
                        </p>
                      </div>
                      <div className="virtual_games">
                        {/* <img
                          src={require("../../image/new_token-development/art&music.webp")}
                          alt="Token Development Company"
                        /> */}
                        <h3>Security</h3>
                        <p>
                          Designed with advanced protocols to safeguard against
                          hacks and breaches.
                        </p>
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="logo_clinet_img token-dev">
                      <div className="virtual_games">
                        {/* <img
                          src={require("../../image/new_token-development/fintch.webp")}
                          alt="Token Development Company"
                        /> */}
                        <h3>Interoperability</h3>
                        <p>
                          Seamlessly integrate with other platforms and
                          blockchains.
                        </p>
                      </div>
                      <div className="virtual_games">
                        {/* <img
                          src={require("../../image/new_token-development/Agricultural.webp")}
                          alt="Token Development Company"
                        /> */}
                        <h3>Customizability</h3>
                        <p>
                          Fully customizable to meet your specific requirements.
                        </p>
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="logo_clinet_img token-dev">
                      <div className="virtual_games">
                        {/* <img
                          src={require("../../image/new_token-development/RealEstate.webp")}
                          alt="Token Development Company"
                        /> */}
                        <h3>Regulatory Compliance</h3>
                        <p>
                          Designed to comply with relevant regulations and
                          standards.
                        </p>
                      </div>
                      {/* <div className="virtual_games">
                        <img
                          src={require("../../image/new_token-development/medicine.webp")}
                          alt="Token Development Company"
                        />
                        <h3>Medicine</h3>
                      </div> */}
                    </div>
                  </Slider>
                </div>
              </div>
            </section>
            <section className="process-of-crypto-token-section">
              <div className="container">
                <div className="our-premium-crypto-heading blockchain-platforms">
                  <h3>Our</h3>
                  <h2>Development Process</h2>
                  <p>
                    At our crypto token development company, we follow a
                    structured and transparent process to ensure the success of
                    every project:
                  </p>
                </div>
                <div className="process-of-line">
                  <img
                    src={require("../../image/new_token-development/process-of-line.webp")}
                    alt="Token Development Company"
                  />
                </div>
                <div className="row">
                  <div className="col-lg-2">
                    <div className="meeting-to-begin">
                      <h4>Requirement Analysis</h4>
                      <p>
                        Analyzing requirements to understand your objectives,
                        target audience, and desired features.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="meeting-to-begin">
                      <h4>Token Design</h4>
                      <p>
                        Designing the token’s structure, features, and
                        specifications.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="meeting-to-begin">
                      <h4>Smart Contract Development</h4>
                      <p>
                        Writing and testing the smart contract to govern the
                        token’s functionality.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="meeting-to-begin-1">
                      <h4>Testing and Auditing</h4>
                      <p>
                        Conducting extensive testing to ensure security and
                        functionality.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="meeting-to-begin-1">
                      <h4>Deployment </h4>
                      <p>
                        Launching the token on the chosen blockchain network.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/*  */}
            <section className="section bg-white technological-stack-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto technological-stack-content">
                      <h2 className="text_ceeenter">Technological Stack</h2>
                      <p>
                        Your Success Rate Is Directly Proportional To The
                        Technology You Utilise
                        <br /> To Manufacture Your Token. That Is Why We Choose
                        The Most Modern
                        <br /> Technology.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="smart_content">
                      <ul>
                        <li>
                          <img
                            src={require("../../image/new_token-development/type-script.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/react.webp")}
                            alt="Token Development Company"
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/next-js.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/angular.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/node-js.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/docker.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/azure.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/truffle.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/solidity.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/ethereum.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                        <li>
                          <img
                            src={require("../../image/new_token-development/rust.webp")}
                            alt="Token Development Company"
                            className=""
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="why-you-choose-beleaf-section">
              <div className="container">
                <div className="our-premium-crypto-heading blockchain-platforms">
                  {/* <h3>Why You Choose Beleaf As</h3> */}
                  <h2>Industries We Serve</h2>
                  <p>
                    As a versatile crypto token development company, we cater to
                    a wide range of industries:
                  </p>
                </div>
                <Crypto_Token_Slider />
              </div>
            </section>

            <section className="crypt-future-outer">
              <div className="container">
                <div className="our-premium-crypto-heading ">
                  <h2 className="crypt-future-heading">
                    <span className="crypt-future-span">The Future of </span>{" "}
                    Crypto Token Development
                  </h2>
                  <p className="crypt-future-content">
                    As the adoption of blockchain technology continues to grow,
                    the role of tokens in driving innovation across industries
                    becomes increasingly significant. Our crypto token
                    development company stays ahead of the curve by integrating
                    cutting-edge technologies and following emerging trends.
                    From creating environmentally sustainable tokens to
                    exploring new use cases in the metaverse, we are committed
                    to delivering forward-thinking solutions.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <div className="container">
                <div className="our-premium-crypto-heading ">
                  <h2 className="crypt-future-heading">
                    Why Blockchain Technology Matters
                  </h2>
                  <p>
                    Blockchain technology is transforming industries by
                    providing:
                  </p>
                  <div className="row why-blockchan-row">
                    <div className="col-lg-3">
                      <div className="technical-why-choose-card why-block-col">
                        <h4>Transparency</h4>
                        <p>
                          {" "}
                          Immutable and transparent records of transactions.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="technical-why-choose-card why-block-col">
                        <h4>Decentralization</h4>
                        <p>
                          {" "}
                          Elimination of intermediaries, reducing costs and
                          delays.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="technical-why-choose-card why-block-col">
                        <h4>Security</h4>
                        <p>
                          {" "}
                          Advanced encryption and consensus mechanisms ensure
                          data integrity.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="technical-why-choose-card why-block-col">
                        <h4>Efficiency</h4>
                        <p>
                          {" "}
                          Faster and more efficient processes across industries.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="crypt-future-outer">
              <div className="container">
                <div className="our-premium-crypto-heading ">
                  <h2 className="crypt-future-heading">
                    Get Started with the Leading{" "}
                    <span className="crypt-future-span">Crypto Token</span>{" "}
                    Development Company
                  </h2>
                  <p className="crypt-future-content">
                    Are you ready to take your business to the next level with
                    innovative crypto token solutions? Our crypto token
                    development company is here to turn your vision into
                    reality. Contact us today to discuss your project and
                    receive a tailored solution that meets your needs.Let's work
                    together to define the future of digital assets.
                  </p>
                </div>
              </div>
            </section>

            {/* Ask Your Problem */}
            <section className="ask-your-problem-form-section crypto-token-tell-us-section">
              <div className="container">
                <div className="form-title">
                  <h3> Tell Us Your Problem</h3>
                  <h2>We will give you an innovative solution</h2>
                </div>
                <div className="form-details">
                  <div className="name-mail">
                    <div className="form-name">
                      <p>Name</p>
                      <input
                        type="text"
                        placeholder="Enter your full name"
                        className="form-control is-untouched is-pristine av-invalid form-control"
                        value={username}
                        minLength={3}
                        maxLength={25}
                        name="username"
                        onChange={handleNewFormChange}
                      ></input>
                      {usernameErr && usernameErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.username}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-mail">
                      <p>E-mail</p>
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        className="form-control is-untouched is-pristine av-invalid form-control"
                        value={useremail}
                        name="useremail"
                        onChange={handleNewFormChange}
                      ></input>
                      {useremailErr && useremailErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.useremail}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="decribe-problem">
                    <div className="form-group decribe-your-problem">
                      <label htmlFor="comment">Problem</label>
                      <textarea
                        className="form-control"
                        rows="5"
                        minLength={5}
                        maxLength={250}
                        placeholder="Decribe your problem in 256 words."
                        name="usermessage"
                        value={usermessage}
                        onChange={handleNewFormChange}
                        id="comment"
                      ></textarea>
                      {usermessageErr && usermessageErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErrors.usermessage}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="get-solution-btn">
                      <a
                        // href="/contact-us"
                        className="contact_bunt get-quote-btn live-demo"
                        onClick={() => sendQuestion()}
                      >
                        Get Solution <i className="ri-arrow-right-line"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/*  */}
            <section className="successfully-deployed-tokens">
              <div className="container">
                {/*Token Slider  */}
                <div className="our-premium-crypto-heading blockchain-platforms">
                  <h3>successfully deployed tokens</h3>
                  <h2>for our valuable clients</h2>
                </div>
                <div>
                  <Slider {...processes_newew}>
                    <div className="logo_clinet_img token-dev reksy">
                      <img
                        src={require("../../image/new_token-development/reksy-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev reksy">
                      <img
                        src={require("../../image/new_token-development/mitcome-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/retire-slider.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev ">
                      <img
                        src={require("../../image/new_token-development/edufex-slider.webp")}
                        alt="Crypto Token development"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img5.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img6.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img7.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img8.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img9.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img10.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev sricoin">
                      <img
                        src={require("../../image/new_token-development/slider-img11.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                    <div className="logo_clinet_img token-dev">
                      <img
                        src={require("../../image/new_token-development/slider-img12.webp")}
                        alt="Token Development Company"
                      />
                    </div>
                  </Slider>
                </div>
                {/*  */}
              </div>
            </section>

            <section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 align-items-center d-flex">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What is a crypto token?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    A crypto token is a digital asset created on
                                    a blockchain that represents a unit of
                                    value. Tokens can serve various purposes,
                                    such as utility, security, or digital
                                    ownership.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    How much does it cost to develop a crypto
                                    token?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The cost of crypto token development depends
                                    on factors like the type of token, desired
                                    features, and the blockchain platform.
                                    Contact our crypto token development company
                                    for a custom quote.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    What platforms do you support?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    We support a wide range of blockchain
                                    platforms, including Ethereum, Binance Smart
                                    Chain, Solana, Polygon, and more.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    Do you provide post-launch support?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, our crypto token development company
                                    offers comprehensive post-launch support to
                                    ensure the ongoing success of your token.
                                  </div>
                                </div>
                              </div>
                              {/* <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    What are the steps involved in creating a
                                    custom crypto token?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The process typically includes defining
                                    token specifications (like supply,
                                    distribution, and utility), developing smart
                                    contracts on a suitable blockchain platform
                                    (like Ethereum or Binance Smart Chain),
                                    conducting audits for security and
                                    compliance, and finally, launching and
                                    marketing the token.
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
